export default __webpack_public_path__ + "static/media/mconferences2.6c42cea5.jpg";